/** @format */

const pm = {
    pm_ai_add: "/assets/images/svg/pm/AI-add.svg",
    pm_manual_add: "/assets/images/svg/pm/Manual-add.svg",
    pm_ai_add_picto: "/assets/images/svg/pm/Robot-Studying-2--Streamline-Manchester.svg",
    pm_manual_add_picto: "/assets/images/svg/pm/Filling-Survey--Streamline-Manchester.svg",
}

export default pm
